import { createContext, useContext, useState } from "react";
import toast from "react-hot-toast";
import { Redirect, useHistory } from "react-router-dom";
import { api } from "../../api";

const AuthContext = createContext({});

const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }

  return context;
};

function AuthProvider({ children }) {
  const history = useHistory();
  const [data, setData] = useState(() => {
    const accessToken = localStorage.getItem("@anthorflix:accessToken");
    const user = localStorage.getItem("@anthorflix:user");
    const bearer = {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    };

    if (accessToken && user) {
      return { accessToken, user: JSON.parse(user), bearer };
    }

    return {};
  });

  const signIn = async ({ email, password }) => {
    await api
      .post("/users/login", { email, password })
      .then((res) => {
        console.log("Entrou!");
        const { token, user } = res.data;
        localStorage.setItem("@anthorflix:user", JSON.stringify(user));
        localStorage.setItem("@anthorflix:accessToken", token);
        setData({ token, user });
        toast.success("Login efetuado com sucesso!");
        setTimeout(() => {
          return <Redirect to="/dashboard" />;
        }, 3000);
      })
      .catch((err) => {
        console.log("deu erro no login");
        toast.error(err.response.data.message);
      });
  };

  const signUp = async ({ name, email, password }) => {
    await api
      .post("/users/register", { name, email, password })
      .then((res) => {
        history.push("/");
        toast.success("Cadastro realizado com sucesso!");
      })
      .catch((err) => {
        toast.error(err.response.data.error);
      });
  };

  const signOut = () => {
    localStorage.removeItem("@anthorflix:accessToken");
    localStorage.removeItem("@anthorflix:user");
    setData({});
    toast("Você foi desconectado :)");
    history.push("/");
  };

  return (
    <AuthContext.Provider
      value={{
        accessToken: data.accessToken,
        user: data.user,
        signIn,
        signOut,
        signUp,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export { AuthProvider, useAuth };
